export default function () {
  const { t } = useI18n()

  const ErrorStatus = {
    404: {
      statusCode: 404,
      statusMessage: t('app.404.statusMessage')
    }
  } as const

  type ErrorStatus = keyof typeof ErrorStatus

  const throwError = (status: ErrorStatus) => {
    throw createError({
      statusCode: ErrorStatus[status].statusCode,
      statusMessage: ErrorStatus[status].statusMessage
    })
  }

  return {
    throwError
  }
}
